export const toIsoDate = (dateStr) => {
  if (!dateStr) return '';
  const [month, day, year] = dateStr.split('/');
  if (!year || !month || !day) return dateStr;
  return `${year.padStart(4, '0')}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

export const parseCsvRows = (rows, yesNoToBool) =>
  rows.map((row) => ({
    patient_id: parseInt(row.MRN, 10),
    start_date: toIsoDate(row['Date Start']),
    end_date: toIsoDate(row['Date End']),
    chart_notes: yesNoToBool(row['Chart Notes']),
    bgm_reading_logs: yesNoToBool(row['Reading Logs (BGM)']),
    cgm_reading_logs: yesNoToBool(row['Reading Logs (CGM)']),
    orders_and_consent: yesNoToBool(row['Orders & Informed Consent']),
    rpm_claim_documentation: yesNoToBool(row['RPM Claim Documentation']),
    em_claim_documentation: yesNoToBool(row['E/M Claim Documentation']),
    hawb_claim_documentation: yesNoToBool(row['HAWB Claim Documentation']),
    ccm_claim_documentation: yesNoToBool(row['CCM Claim Documentation']),
    blood_pressure: yesNoToBool(row['Blood Pressure']),
    med_pickup_date: yesNoToBool(row['Med Pickup Date']),
    hba1c: yesNoToBool(row.HbA1c),
  }));
